{
	"transactionCardHeader": "Validar una transacción",
	"transactionCardDescriptionBold": "¿Quieres validar una transacción para cualquier proyecto?",
	"transactionCardDescriptionRegular": "Si tienes un número de transacción a la mano, puedes ingresarlo aquí y validar la transacción.",
	"showTransactionButton": "Mostrar transacción",
	"transactionLabel": "Número de transacción",
	"errors": {
		"transactionIdRequired": "Se requiere el número de transacción.",
		"transactionNotFound": "No se encontró ninguna transacción.",
		"transactionIdInvalid": "Número de transacción no válido."
	}
}
